import { render, staticRenderFns } from "./ModalLaudosJaSolicitados.vue?vue&type=template&id=44d0e797&lang=pug"
import script from "./ModalLaudosJaSolicitados.vue?vue&type=script&lang=js"
export * from "./ModalLaudosJaSolicitados.vue?vue&type=script&lang=js"
import style0 from "./ModalLaudosJaSolicitados.vue?vue&type=style&index=0&id=44d0e797&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports